module.exports = __webpack_public_path__ + "media/images/m-top-7e13a43f.png";